import axios from 'axios';

export default {
    async getCurrent() {
        let response = await axios.get('/api/user');
        return response.data;
    },
    async updatePreferences(preferences) {
        let response = await axios.post('/api/user/updatePreferences', { preferences });
        return response.data;
    },
    async findByPin(pin) {
        let response = await axios.post('/api/users/findByPin', { pin });
        return response.data;
    },
};
